import { useQuery } from '@tanstack/react-query';

import { get } from '../api/ventura/advertiser';
import { isAchHost } from '../util/achAuth';
import { unwrapAchShowModel } from '../util/achEnvelope';
import { useConfig } from './useConfig';

function useAdvertiser(advertiserId: number) {
  const { apiHostFor } = useConfig();

  // Advertisers show opts into the per-domain flip (ACH-colk):
  // apiHostFor('advertisers') resolves to ACH iff advertisers is flipped ON
  // (migrated list + env gate), else the plain Rails apiHost. When served by
  // ACH the response adopts the D2 `{model}` envelope (RD-2), so unwrap it back
  // to the bare advertiser the consumer already expects — a no-op on Rails.
  const advertisersHost = apiHostFor('advertisers');

  const query = useQuery({
    queryKey: ['advertisers', advertiserId],
    queryFn: () => get(advertisersHost, advertiserId).then((res) => unwrapAchShowModel(res, isAchHost(advertisersHost))),
    enabled: !!advertiserId,
  });

  return query;
}

export default useAdvertiser;
